import { useCallback, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { getTankApi, updateTankApi } from '@/apis/tanks'
import useNotification from '@/hooks/useNotification'
import { SuccessResponse, Tank } from '@/types'
import { GetTankRequest } from '@/types/apis/tanks/getTankRequest'
import { UpdateTankRequest } from '@/types/apis/tanks/updateTankRequest'

export const useUpdateTanks = () => {
  const { t } = useTranslation()
  const openNotification = useNotification()
  const [loading, setLoading] = useState(false)
  const [response, setResponse] = useState<SuccessResponse>()

  const update = useCallback(
    async (request: UpdateTankRequest) => {
      try {
        setLoading(true)
        const res = await updateTankApi(request)
        setResponse(res)
        openNotification({ type: 'success', description: t('components.pages.admins.common.update.success') })
      } catch {
        openNotification({ type: 'error', description: t('components.pages.admins.common.update.fail') })
      } finally {
        setLoading(false)
      }
    },
    [openNotification, t]
  )

  return {
    loading,
    updateTank: update,
    response,
  }
}

export const useGetTank = () => {
  const [loading, setLoading] = useState(false)
  const [response, setResponse] = useState<Tank>()

  const get = useCallback(async (request: GetTankRequest) => {
    try {
      setLoading(true)
      const res = await getTankApi(request)
      setResponse(res)
    } finally {
      setLoading(false)
    }
  }, [])

  return {
    loading,
    getTank: get,
    response,
  }
}
